import {Component} from '@angular/core';
import {WizardPageBaseComponent} from '@utils-lib';
import {FreistellungsbescheinigungAngaben} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'common-ui-freistellungsbescheinigung-angaben',
  templateUrl: './freistellungsbescheinigung-angaben.component.html'
})
export class FreistellungsbescheinigungAngabenComponent extends WizardPageBaseComponent<FreistellungsbescheinigungAngaben> {

  static nutzdatenPath = 'freistellungsbescheinigungAngaben';
  static route = 'freistellungsbescheinigung-angaben';

  constructor(protected readonly activatedRoute: ActivatedRoute) {
    super(activatedRoute);
  }

  protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
    return new Map<string, unknown | Array<unknown>>([]);
  }
}
